import React from "react";

import { useTranslation } from "utils";

import { Flex, Icon, Tooltip } from "components";

export type MultiCropSelectionBarProps = {
  selectedCount: number;
  onEdit: () => void;
  onClear: () => void;
};

export const MultiCropSelectionBar = ({ selectedCount, onEdit, onClear }: MultiCropSelectionBarProps) => {
  const { t } = useTranslation("fieldTimeline");

  return (
    <Flex className="multi-crop-selection-bar" align="center" justify="space-between">
      <Flex align="center" gap={"0.5rem"}>
        <p className="selection-count">{selectedCount}</p>
        <p className="selection-text">{t("multiSelection.selected")}</p>
        <Tooltip placement="top" title={t("multiSelection.clear")}>
          <Icon className="selection-bar-icon" iconName="tabler/x" color="white" size="s" onClick={onClear} />
        </Tooltip>
      </Flex>
      <Tooltip placement="top" title={t("multiSelection.addOrEdit")}>
        <Icon className="selection-bar-icon" iconName="klim/edit" color="white" size="m" onClick={onEdit} />
      </Tooltip>
    </Flex>
  );
};
